import React from 'react';
import { string, bool, shape } from 'prop-types';

const ApplianceError = ({ directDelivery, twoTileToggle }) => {
  return (
    <div className="fulfillment__unavailable">
      <fieldset className="fulfillment__unavailable--fieldset">
        {!twoTileToggle && <legend className="fulfillment__unavailable--title">How To Get it</legend> }
        <div className="fulfillment__unavailable__wrapper">
          {directDelivery.subTemplate}
        </div>
      </fieldset>
    </div>
  );
};

ApplianceError.propTypes = {
  directDelivery: shape({
    method: string,
    enabled: bool,
  }),
  twoTileToggle: bool
};
ApplianceError.defaultProps = {
  directDelivery: null,
  twoTileToggle: false
};

export { ApplianceError };
